import { END_POINTS } from '../helpers';
import { ColorData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetColorResponse = {
  count: number;
  data: ColorData[];
};

export const bodyType = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getColor: builder.query<
      CommonResponse & { data: GetColorResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getColors}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteColor: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteColor}/${id}`,
        method: 'DELETE',
      }),
    }),
    getColorById: builder.query<CommonResponse & { data: ColorData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getColorById}/${id}`,
        method: 'GET',
      }),
    }),

    addColor: builder.mutation<CommonResponse & { data: ColorData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addColor}`,
        method: 'POST',
        body,
      }),
    }),
    updateColor: builder.mutation<
      CommonResponse & { data: ColorData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateColor}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddColorMutation,
  useUpdateColorMutation,
  useLazyGetColorQuery,
  useLazyDeleteColorQuery,
  useLazyGetColorByIdQuery,
} = bodyType;
